module.exports = __webpack_public_path__ + "media/img/vimeo-play-dfe7764b4fe444c3880736ac6131f5b4.png";